import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalyticsKPICard = ({ title, value, subtitle, icon, trend, status }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'compliant':
        return {
          bg: 'bg-success/10',
          text: 'text-success',
          border: 'border-success/20'
        };
      case 'warning':
        return {
          bg: 'bg-warning/10',
          text: 'text-warning',
          border: 'border-warning/20'
        };
      case 'critical':
        return {
          bg: 'bg-error/10',
          text: 'text-error',
          border: 'border-error/20'
        };
      default:
        return {
          bg: 'bg-muted',
          text: 'text-muted-foreground',
          border: 'border-border'
        };
    }
  };

  const getTrendIcon = () => {
    if (trend > 0) return 'TrendingUp';
    if (trend < 0) return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend > 0) return 'var(--color-success)';
    if (trend < 0) return 'var(--color-error)';
    return 'var(--color-muted-foreground)';
  };

  const styles = getStatusStyles();

  return (
    <div className={`bg-card border ${styles?.border} rounded-lg p-4 md:p-6 transition-smooth hover:shadow-md`}>
      <div className="flex items-start justify-between mb-3">
        <div className={`${styles?.bg} ${styles?.text} p-2 md:p-3 rounded-md`}>
          <Icon name={icon} size={20} color="currentColor" />
        </div>
        {trend !== undefined && (
          <div className="flex items-center gap-1">
            <Icon name={getTrendIcon()} size={16} color={getTrendColor()} />
            <span className="data-text text-xs font-medium" style={{ color: getTrendColor() }}>
              {Math.abs(trend)}%
            </span>
          </div>
        )}
      </div>
      <h3 className="caption text-xs md:text-sm text-muted-foreground mb-2">{title}</h3>
      <div className="flex items-baseline gap-2 mb-1">
        <span className={`text-2xl md:text-3xl lg:text-4xl font-heading font-bold ${styles?.text}`}>
          {value}
        </span>
      </div>
      {subtitle && (
        <p className="caption text-xs text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
};

export default AnalyticsKPICard;
